import { combineReducers } from 'redux';

import authReducer from './authReducer';
import commonReducer from './commonReducer';
import adminDashboardReducer from './adminDashboardReducer';
import mainDashboardReducer from './mainDashboardReducer';
import SiteConfigReducer from './siteConfigReducer';
import managementReducer from './managementReducer';
import returnNoteReducer from './returnNoteReducer';
import reportsReducer from './reportsReducer';

const rootReducer = combineReducers({ 
    auth: authReducer,
    common: commonReducer,
    adminDashboardReducer,
    mainDashboard: mainDashboardReducer,
    config:SiteConfigReducer,
    managementReducer,
    returnNote: returnNoteReducer,
    report: reportsReducer,
});

export default rootReducer;